import Animated from 'react-native-reanimated'

import { useWindowDimensions } from 'react-native'
import { View } from 'react-native'
import { Text, Icon } from 'react-native-paper'
import { createStyle } from '../../../../../contexts/global-styles.provider'
import { useTranslation } from 'react-i18next'
import {
  Icon3dContributions,
  IconGoTo,
  IconNoVotes,
} from '../../../../../utils/meldd-icons'
import { CardLayout, Row } from '../../../../../@ui'

interface ClusterListItemProps {
  onPress: () => void
  onClusterContributionsPress: () => void
  cluster: {
    id: string
    nodeId: string
    topic: string
    articlesCount: number
    contributionsCount: number
    votesCount: number
  }
}
export const ClusterCard = ({
  cluster,
  onPress,
  onClusterContributionsPress,
}: ClusterListItemProps) => {
  const { width } = useWindowDimensions()
  const { t } = useTranslation('clusters')
  const styles = useStyle()

  return (
    <Animated.View>
      <CardLayout onPress={onPress}>
        <View style={styles.info}>
          <Text
            variant={width < 480 ? 'titleSmall' : 'titleMedium'}
            style={styles.title}
          >
            {cluster.topic}
          </Text>
          <Row columnGap={8} alignItems="center">
            <Row flex={1}>
              <Icon source={IconGoTo} size={24} />
              <Text variant="bodySmall" style={styles.iconText}>
                {cluster.articlesCount}{' '}
                {cluster.articlesCount === 1
                  ? t('perspective')
                  : t('perspectives')}
              </Text>
              <View style={{ margin: 6 }} />

              <Icon3dContributions
                size={24}
                label={cluster.contributionsCount.toString()}
                onPress={() => onClusterContributionsPress()}
              />

              <IconNoVotes size={24} label={cluster.votesCount.toString()} />
            </Row>
          </Row>
        </View>
      </CardLayout>
    </Animated.View>
  )
}

const useStyle = createStyle(({ theme }) => ({
  info: {
    flex: 1,
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  iconText: {
    marginLeft: theme.spacing(1),
  },
}))
